<!-- <div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="text-2xl font-bold text-[#C42727]" i18n="@@undeliveredReasonsPageTitle">Undelivered Reasons</h1>
    <a
      routerLink="/admin/undelivered-reasons/add-undelivered-reason"
      class="add-button flex items-center justify-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
      </svg>
      <span i18n="@@undeliveredReasonsCreateButton">Create New Reason</span>
    </a>
  </div>

  <app-undelivered-reasons-list-component />
</div> -->



<app-undelivered-reasons-list-component></app-undelivered-reasons-list-component>